<template>
  <div class="mheader-page">
    <div class="tabs">
      <img src="../assets/image/mobile/mhome/logo.png" alt="" class="logo" />
      <img
        src="../assets/image/mobile/mhome/tab.png"
        alt=""
        class="tab"
        v-if="!isexpand"
        @click="expand()"
      />
      <img
        v-if="isexpand"
        src="../assets/image/mobile/mhome/tab2.png"
        alt=""
        class="tab"
        @click="expand()"
      />
    </div>
    <!-- 展开内容 -->
    <ul class="content" v-if="isexpand">
      <li
        class="item"
        v-for="(item, index) in navList"
        @click="changeTab(index)"
        :key="item.id"
      >
        <router-link
          :to="item.link"
          class="link"
          :class="{ active: tabIndex === index }"
        >
          {{ item.desc }}</router-link
        >
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isexpand: true,
      navList: [
        {
          id: "tab1",
          desc: "首页",
          link: "/homePage",
        },
        {
          id: "tab2",
          desc: "品牌介绍",
          link: "/brand",
        },
        {
          id: "tab3",
          desc: "招商加盟",
          link: "/joinUs",
        },
        {
          id: "tab4",
          desc: "媒体中心",
          link: "/news",
        },
      ],
      tabIndex: 0,
    };
  },
  methods: {
    expand() {
      this.isexpand = !this.isexpand;
    },
    changeTab(index) {
      this.tabIndex = index;
    },
  },
  watch: {
    $route(to, from) {
      switch (to.path) {
        case "/homePage":
          this.tabIndex = 0;
          break;
        case "/brand":
          this.tabIndex = 1;
          break;
        case "/joinUs":
          this.tabIndex = 2;
          break;
        case "/news":
          this.tabIndex = 3;
          break;
        case "/hotelScene":
          this.tabIndex = 2;
          break;
      }
      this.isexpand = false;
    },
  },
};
</script>

<style lang="less" scoped>
.mheader-page {
  width: 100%;
  // background-color: #000;
  // opacity: 0.85;
  // background-color: rgb(0, 0, 0.85);
  position: fixed;
  left: 0;
  top: 0;
  z-index: 9999;
  .tabs {
    background-color: #000;
    opacity: 1 !important;
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    height: (45/ 3.75vw);
    padding: 0 (23/ 3.75vw);

    .logo {
      width: (51/ 3.75vw);
    }
    .tab {
      width: (18/ 3.75vw);
    }
  }
  .content {
    background-color: #000;
    opacity: 0.95;
    height: calc(100vh - 10.6vw);
    padding-top: (56 / 3.75vw);
    li {
      height: (68 / 3.75vw);
      display: flex;
      justify-content: center;
      align-items: center;
      // border-bottom: 1px dashed #eee;
    }
    .link {
      padding-bottom: (10 / 3.75vw);
      font-size: (16/ 3.75vw);
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #fff;
    }
    .active {
      border-bottom: 2px solid #ea5717;
    }
  }
}
</style>